import Divider from "@mui/material/Divider";

import { Layout } from "~landing/components/layout";
import { FeaturesSection } from "~landing/components/pricing/features";
import { PlansTable } from "~landing/components/pricing/plans-table";
import { StartBuilding } from "~landing/components/pricing/start-building";

export function Pricing() {
	return (
		<Layout>
			<main>
				<PlansTable />
				<Divider />
				<FeaturesSection />
				<StartBuilding />
			</main>
		</Layout>
	);
}
